import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import avtar1 from '../../assets/images/user/avatar-1.jpg'
import { deleteData, getData, imgUrl } from '../Services/api'
import Pagination from '../Services/Pagination'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const UserList = () => {
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');

    const fetchUsers = async (pageNumber = 1, searchQuery = '') => {
        try {
            const res = await getData(`/users?page=${pageNumber}&search=${searchQuery}`);
            if (res.status) {
                setUsers(res.data || [])
                setPage(res.pagination.page);
                setPages(res.pagination.pages);
                setTotal(res.pagination.total);
            }
        } catch (error) {
            console.log("error fetch users", error)
        }
    }

    useEffect(() => {
        fetchUsers(page, search);
    }, [page, search]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            fetchUsers(pageNumber);
        }
    };

    const handleDelete = (userId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/users/user-delete/${userId}`,);
                    if (res.status) {
                        toast.success(res.message);
                        fetchUsers();
                    }
                } catch (error) {
                    console.log("error delete user", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/users/user-list">Users</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Users List
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Users List</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="d-sm-flex align-items-center p-4">
                                        <ul className="list-inline me-auto my-1">
                                            <li className="list-inline-item">
                                                <div className="form-search">
                                                    <i className="fas fa-search" />
                                                    <input
                                                        type="search"
                                                        className="form-control"
                                                        placeholder="Search Users"
                                                        value={search}
                                                        onChange={(e) => {
                                                            setSearch(e.target.value);
                                                            setPage(1);
                                                        }}
                                                    />
                                                </div>
                                            </li>
                                        </ul>

                                        <div className="text-end pb-sm-2">
                                            <Link
                                                to="/users/add-user"
                                                className="btn btn-primary d-inline-flex align-item-center"
                                            >
                                                <i className="fas fa-plus f-18 me-2" /> Add User
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>User Details</th>
                                                    <th>Mobile</th>
                                                    <th>Gender</th>
                                                    <th>Dob</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    users?.length > 0 ? (
                                                        users?.map((user, index) => {
                                                            return (
                                                                <tr key={user._id}>
                                                                    <td>{index + 1 + (page - 1) * 10}.</td>
                                                                    <td>
                                                                        <div className="row">
                                                                            <div className="col-auto">
                                                                                <img
                                                                                    src={
                                                                                        user?.profileImage
                                                                                            ? user.profileImage.startsWith("http")
                                                                                                ? user.profileImage
                                                                                                : `${imgUrl}${user.profileImage}`
                                                                                            : avtar1
                                                                                    }
                                                                                    alt="user-image"
                                                                                    className="wid-40 rounded-circle"
                                                                                />
                                                                            </div>
                                                                            <div className="col">
                                                                                <h6 className="mb-0">{user.fullname}</h6>
                                                                                <p className="text-muted f-12 mb-0">
                                                                                    {user.email}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>{user.mobile}</td>
                                                                    <td>{user.gender}</td>
                                                                    <td>{user?.dob?.split('T')[0]} </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <Link
                                                                                    to={`/users/view-user/${user._id}`}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-eye f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/users/update-user/${user._id}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Delete"
                                                                            >
                                                                                <a
                                                                                    onClick={() => handleDelete(user._id)}
                                                                                    className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={6} className='text-center'>No Users Found</td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                        <div className="text-muted">
                                            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                        </div>
                                        <Pagination
                                            page={page}
                                            pages={pages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserList